<template>
    <div class="mr-1 mr-md-3">
        <label class="mt-3">{{ label }}</label>
        <b-form-group>
            <b-form-input
                type="range"
                v-model="minValue"
                :min="0"
                :max="5000"
                step="10"
                @input="updateMin"
            />
            <b-form-input
                type="range"
                v-model="maxValue"
                :min="0"
                :max="5000"
                step="10"
                @input="updateMax"
            />
            <small>Rango: {{ minValue | formatear_precio }} - {{ maxValue | formatear_precio }}</small>
        </b-form-group>
    </div>
</template>

<script>
    export default {
        props: ['label', 'min', 'max'],
        data() {
            return {
                minValue: this.min,
                maxValue: this.max
            };
        },
        watch: {
            min(newVal) {
                this.minValue = newVal;
            },
            max(newVal) {
                this.maxValue = newVal;
            }
        },
        methods: {
            updateMin() {
                this.$emit('update:min', this.minValue);
                this.getFacturas();
            },
            updateMax() {
                this.$emit('update:max', this.maxValue);
                this.getFacturas();
            },
            getFacturas() {
                this.$emit('getFacturas');
            }
        }
    };
</script>
